import type { IBrand } from "../../../../types/models/brands.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  brand: IBrand;
}

export function useGetBrandByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/brands/:id",
  });
}
